import { z } from 'zod'

const readingStyleEnum = z.enum([
  'slow-paced',
  'weekly-discussion',
  'fast-reads',
  'finish-then-discuss',
])

export const createClubSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name must be 100 characters or less'),
  description: z.string().max(500, 'Description must be 500 characters or less').optional(),
  genreIds: z
    .array(z.string())
    .min(1, 'Select at least 1 genre')
    .max(3, 'Select at most 3 genres')
    .optional(),
  readingStyle: readingStyleEnum.optional(),
})

export const updateClubSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name must be 100 characters or less').optional(),
  description: z.string().max(500, 'Description must be 500 characters or less').optional(),
  readingStyle: readingStyleEnum.optional(),
})

export type CreateClubInput = z.infer<typeof createClubSchema>
export type UpdateClubInput = z.infer<typeof updateClubSchema>
